import { ColumnOrderState, Table } from "@tanstack/react-table";
import { ListGroup, Offcanvas } from "react-bootstrap";
import { Booking } from "../booking-page/store/slice";
import styles from "./bookingColumns.module.scss";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ColumnItem from "./ColumnItem";
import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import bookingSettingSlice from "../booking-settings/store/slice";

type Props = {
  show: boolean;
  table: Table<Booking>;
  handleClose: () => void;
};

const BookingColumns = ({ show, table, handleClose }: Props) => {
  const dispatch = useDispatch();

  const columnOrder = useSelector((state) => state.bookingSettings.columnOrder);

  const columns = useMemo(() => table.getAllLeafColumns(), [table]);

  const setColumnOrder = useCallback(
    (state: ColumnOrderState) =>
      dispatch(bookingSettingSlice.actions.setColumnOrder(state)),
    [dispatch]
  );

  const moveColumn = useCallback(
    (dragIndex: number, hoverIndex: number) => {
      const newOrder = [...columnOrder];

      const element = newOrder[dragIndex];
      newOrder.splice(dragIndex, 1);
      newOrder.splice(hoverIndex, 0, element);

      setColumnOrder(newOrder);
    },
    [setColumnOrder, columnOrder]
  );

  return (
    <Offcanvas show={show} onHide={handleClose} placement="end" scroll>
      <Offcanvas.Header closeButton className={styles.header}>
        <Offcanvas.Title>Columns</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className={styles.body}>
        <DndProvider backend={HTML5Backend}>
          <ListGroup variant="flush" className="shadow-sm">
            {columnOrder.map((id, index) => (
              <ColumnItem
                key={index}
                index={index}
                column={columns.find((column) => column.id === id)!}
                moveColumn={moveColumn}
              />
            ))}
          </ListGroup>
        </DndProvider>
        <span className={styles.description}>
          Drag and drop to reorder columns.
        </span>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default BookingColumns;
